import { IconCheck, IconX } from '@tabler/icons-react';
import { clsx } from 'clsx';
import { ReactNode } from 'react';

import { PasswordRequirementRegexes } from '@/hooks/use-password-strength/constants';

interface PasswordRequirementProps {
  meets: boolean;
  label: ReactNode;
}

export const PasswordRequirement = ({
  meets,
  label,
}: PasswordRequirementProps) => {
  return (
    <div
      className={clsx('mt-1 text-sm flex items-center', {
        'text-success': meets,
        'text-destructive': !meets,
      })}
    >
      {meets ? <IconCheck size={14} /> : <IconX size={14} />}{' '}
      <div className="ml-2">{label}</div>
    </div>
  );
};

export const PasswordRequirements = ({ password }: { password: string }) => {
  return (
    <>
      {PasswordRequirementRegexes.map((requirement, index) => (
        <PasswordRequirement
          key={index}
          label={requirement.label}
          meets={requirement.re.test(password)}
        />
      ))}
    </>
  );
};
